import { render } from "./HiTextCarousel.vue?vue&type=template&id=2575331a"
import script from "./HiTextCarousel.vue?vue&type=script&lang=js"
export * from "./HiTextCarousel.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__